/**
 * CenterSlice Core Reducers
 * 
 * Core operations for the center selection state.
 */

import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { CenterSliceState } from '../state';

// =============================================================================
// CORE REDUCERS
// =============================================================================

/**
 * Set the selected center code
 */
export const setSelectedCenterReducer: CaseReducer<CenterSliceState, PayloadAction<string>> = (
  state,
  action
) => {
  state.selectedCenter = action.payload;
};
